<template>
    <el-input :type="type" class="login-input" :class="{'login-input-prefix' : !!$slots.default}" v-model="input" @input="$emit('input', input)" :placeholder="placeholder">
        <template slot="prefix" v-if="!!$slots.default">
            <span class="prefix" >
                <slot name="default"></slot>
            </span>
        </template>
        <template slot="suffix">
            <span class="suffix">
                <slot name="suffix"></slot>
            </span>
        </template>
    </el-input>
</template>

<script>
    export default {
        name: "loginInput",
        props: {
            placeholder: String,
            value: String,
            type: {
                type: String,
                default: () => 'text',
            }
        },
        data() {
            return {
                input: ''
            }
        },
        watch: {
            value(val) {
                this.input = val
            }
        },
        created() {
            this.input = this.value
            console.log(this.$slots)
        }
    }
</script>

<style lang="scss">
@import "../styles/element-variables";
@media screen and (max-width: $--media-max-width){
    body {
        .login-input-prefix {
            .el-input__inner {
                padding-left: 0.42rem !important;
            }
        }
        .login-input {
            $--input-height: 0.2667rem;
            width: 1.8667rem;
            margin-bottom: 0.08rem;
            .el-input__inner {
                height: $--input-height;
                font-size: 0.0933rem;
            }
            .el-input__inner::-webkit-input-placeholder {
                font-size: 0.0933rem;
            }
            .prefix {
                width: 0.3333rem;
                font-size: 0.1067rem;
                margin-top: 0.055rem;
            }
            .el-input__suffix {
                line-height: 0.2667rem;
            }
        }
    }
}

.login-input-prefix {
    .el-input__inner {
        padding-left: 95px !important;
    }
}
.login-input {
    $--input-height: 60px;
    width: 480px;
    margin-bottom: 20px;
    .el-input__inner {
        height: $--input-height;
        font-size: 20px;
        border-radius: 8px;
        border: solid 1.5px #d0d2f5;
        background-color: #f5f5fd;
    }
    .el-input__inner::-webkit-input-placeholder {
        font-size: 22px;
        color:#aeaddc;
    }
    .prefix {
        width: 77px;
        font-size: 22px;
        position: absolute;
        border-right: 1px solid #e8e8fe;
        margin-top: 12px;
        color: #9f9ed2;
    }
    .el-input__suffix {
        line-height: 60px;
    }
}
</style>
